import Templating from './templating.js';

export default class Engine {


    static init() {
        Templating.registerHelpers();
    }


}
